import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCommentDots,  
  faGraduationCap, 
  faBriefcase, 
  faCalendarCheck, 
  faTasks,
} from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Card, Container } from '@themesberg/react-bootstrap';
import Layout from "../components/Layout";
import FaceRec from "../components/FaceRecognition"; 

const RefugeeDashboard = () => {
  const navigate = useNavigate();
  const [faceRecOpen, setFaceRecOpen] = useState(false);

  const dashboardItems = [
    { title: "Availability", icon: faCalendarCheck, path: "/availability", requiresFace: true },
    { title: "Tasks", icon: faTasks, path: "/task" },
    { title: "Chat", icon: faCommentDots, path: "/chat" },
    { title: "Courses", icon: faGraduationCap, path: "/courses" },
    { title: "Job Opportunities", icon: faBriefcase, path: "/job" },
  ];

  const handleCardClick = (item) => {
    if (item.requiresFace) {
      setFaceRecOpen(true); // <-- open FaceRec immediately
    } else {
      navigate(item.path);
    }
  };

  return (
    <Layout>
      <Container className="px-2">
        <Row className="justify-content-center align-items-center w-100">
          <Row className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4" />

          <Row>
            {dashboardItems.map((item, index) => (
              <Col xs={12} sm={6} xl={4} className="mb-4" key={index}>
                <Card
                  className="text-center shadow-sm"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleCardClick(item)}
                >
                  <Card.Body>
                    <FontAwesomeIcon icon={item.icon} size="3x" className="mb-3" />
                    <Card.Title>{item.title}</Card.Title>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Row>
      </Container>

      {faceRecOpen && (
        <FaceRec
          onVerified={() => {
            setFaceRecOpen(false);
            navigate("/availability");
          }}
          onClose={() => setFaceRecOpen(false)}
        />
      )}
    </Layout>
  );
};

export default RefugeeDashboard;
